import {
  stakingContract,
  tokenContract,
  stakingLpContract,
  lpTokenContract,
} from "./environment";
import stakingAbi from "../Connectivity/skatingAbi.json";
import stakinglpAbi from "../Connectivity/stakingLpAbi.json";
import lptokenAbi from "../Connectivity/lptokenAbi.json";
import tokenAbi from "../Connectivity/tokenAbi.json";
import { Contract } from "@ethersproject/contracts";
import React from "react";
import { useProvider } from "wagmi";

// let walletadress = "0xFf244442B0FB78952aAD680508B3e07e48AA00ff";

// const provider = new ethers.providers.JsonRpcProvider(
//   "https://rpc.ankr.com/bsc"
// );

// const voidAccount = new ethers.VoidSigner(walletadress, provider);

function useContract(address, ABI, signer) {
  let provider = useProvider();
  // console.log(publicClient, "usePublicClient");
  return React.useMemo(() => {
    if (signer) {
      return new Contract(address, ABI, signer);
    } else {
      return new Contract(address, ABI, provider);
    }
  }, [signer, address, ABI, provider]);
}

export function useTokenContract(signer) {
  return useContract(tokenContract, tokenAbi, signer);
}

export function useLPTokenContract(signer) {
  return useContract(lpTokenContract, lptokenAbi, signer);
}

export function useFarmingContract(signer) {
  return useContract(stakingLpContract, stakinglpAbi, signer);
}

export function useStakingContract(signer) {
  return useContract(stakingContract, stakingAbi, signer);
}
